<h1 mat-dialog-title>Create a Site</h1>
<div mat-dialog-content>
  <form #siteForm="ngForm" (ngSubmit)="save()" fxLayout="row wrap">
    <mat-form-field fxFlex="100%">
      <input
        matInput
        #domainName="ngModel"
        placeholder="Domain Name"
        [(ngModel)]="data.domainName"
        autocomplete="domainName"
        name="domainName"
        pattern="[\w-]+(\.[\w-]+)+"
        required
      />
      <mat-error *ngIf="domainName.invalid && (domainName.dirty || domainName.touched)">
        <span *ngIf="domainName.errors.required">Domain Name is required.</span>
        <span *ngIf="domainName.errors.pattern">Invalid Domain Name.</span>
      </mat-error>
    </mat-form-field>
    <mat-form-field fxFlex="100%">
      <mat-select
        #selectedBrand="ngModel"
        placeholder="Brand"
        [(ngModel)]="data.selectedBrand"
        name="selectedBrand"
        [disabled]="disableBrand"
        required
      >
        <mat-option *ngFor="let b of data.brands" [value]="b.id">{{ b.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!siteForm.form.valid">Save Site</button>
</div>
